<h1 mat-dialog-title>{{ 'security-request-status-list-dialog.title' | translate }}</h1>

<mat-dialog-content>
    @if (securityRequests$ | async; as sr) {
        @if (sr.length > 0) {
            <div class="scrollport">
                <table mat-table [dataSource]="sr" aria-describedby="List showing the security requests status">

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>{{'security-request-status-list-dialog.table.created' | translate}}</th>
                        <td mat-cell *matCellDef="let request">{{ request.created_dttm | date}}</td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>{{'security-request-status-list-dialog.table.type' | translate}}</th>
                        <td mat-cell *matCellDef="let request">
                            <a (click)="showRequestStatus(request.id)">
                                @switch (request.type) {
                                    @case (SecurityRequestType.REMOVE_APPROVER) {
                                        {{ 'security-request-status-list-dialog.type.remove-approver' | translate }}
                                    }
                                    @case (SecurityRequestType.ADD_APPROVER) {
                                        {{ 'security-request-status-list-dialog.type.add-approver' | translate }}
                                    }
                                    @case (SecurityRequestType.RECOVERY_KEY) {
                                        {{ 'security-request-status-list-dialog.type.recovery-key' | translate }}
                                    }
                                    @case (SecurityRequestType.DISK_CONFIG) {
                                        {{ 'security-request-status-list-dialog.type.disk-config' | translate }}
                                    }
                                    @case (SecurityRequestType.BITLOCKER_KEY) {
                                        {{ 'security-request-status-list-dialog.type.bitlocker-key' | translate }}
                                    }
                                }
                            </a>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="target_email">
                        <th mat-header-cell *matHeaderCellDef>{{'security-request-status-list-dialog.table.target-email' | translate}}</th>
                        <td mat-cell *matCellDef="let request">
                            {{ request.target_email}}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: columns;">
                    </tr>

                </table>
            </div>
        } @else {
            {{ 'security-request-status-list-dialog.no-pending-requests' | translate }}
        }
    }
</mat-dialog-content>

<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onClose()" type="button">{{ 'CLOSE' | translate}}</button>
</div>
